import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import ClientService from "../../../service/client.service";
import CommonService from "../../../service/common.service";
import { CardData, BoardStage } from "../../../types/board";
import { setResponseValue } from "../api-response/api-response";
import {
  setIntakeStage,
  updateIntakeboardCardsUpdatedAt,
} from "./client-intake-stage";
import { updateCustomBoardCardUpdatedAt } from "../custom-board/custom-board-slice";

interface CardsInitialState {
  [key: string]: CardData[];
}

const initialState: CardsInitialState = {};

const clientBoardSlice = createSlice({
  name: "clientBoardSlice",
  initialState: initialState,
  reducers: {
    setClientTasks: (state, action) => {
      return { ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getClientBoards.fulfilled,
      (state, action: PayloadAction<BoardStage[] | undefined>) => {
        if (action.payload) {
          let cards: CardsInitialState = {};
          action.payload.forEach((item) => {
            cards[item.stageName] = item.boardColumnNames;
          });
          return {
            ...cards,
          };
        } else {
          return { ...initialState };
        }
      }
    );
  },
});

export const getClientBoards = createAsyncThunk(
  "cardsStateSlice/getClientBoards",
  async ({ useLoader }: { useLoader: boolean }, { getState, dispatch }) => {
    try {
      if (useLoader) {
        dispatch(setResponseValue({ name: "pending", value: true }));
      }
      const { data } = await ClientService.getClientBoards();
      dispatch(setIntakeStage(data));
      return data;
    } catch (e: any) {
      dispatch(setResponseValue({ name: "error", value: true }));
      dispatch(setResponseValue({ name: "message", value: e?.message }));
    } finally {
      if (useLoader) {
        dispatch(setResponseValue({ name: "pending", value: false }));
      }
    }
  }
);

//CTO review: need to merge
export const moveClientCardToAnotherBoard = createAsyncThunk(
  "clientBoardSlice/moveClientToAnotherBoard",
  async (
    {
      fromStageId,
      tostageId,
      cardId,
      index,
      boardType,
      boardId
    }: {
      fromStageId: string;
      tostageId: string | null;
      cardId: string;
      index: number;
      boardId?: string;
      boardType?: "custom" | "Default";
    },
    { getState, dispatch }
  ) => {
    try {
      dispatch(setResponseValue({ name: "pending", value: true }));
      const { status, message } = await CommonService.moveToAnotherBoard(
        fromStageId,
        tostageId,
        cardId,
        index
        // "Client"
      );
      if (status) {
        dispatch(setResponseValue({ name: "success", value: true }));
        dispatch(setResponseValue({ name: "message", value: message }));
        //update the card updated at property in redux
        if (boardType === "custom" && boardId) {
          dispatch(
            updateCustomBoardCardUpdatedAt({ cardId, boardId })
          );
        } else {
          dispatch(updateIntakeboardCardsUpdatedAt({ cardId }));
        }
        return { cardId };
      }
    } catch (e: any) {
      dispatch(setResponseValue({ name: "error", value: true }));
      dispatch(setResponseValue({ name: "message", value: e?.message }));
    } finally {
      dispatch(setResponseValue({ name: "pending", value: false }));
    }
  }
);

export const { setClientTasks } = clientBoardSlice.actions;

export default clientBoardSlice;
